/**
 * This class stores product component slots
 * It is used during loading of model and then cached
 */

import * as THREE from "three";


export class Slots{
	protected _slots:{ [key:string]:THREE.Object3D } = {};

	keys():string[]{
		return Object.keys(this._slots);
	}

	/**
	 * Gets slot placeholder with certain name
	 * @param {string} i
	 * @returns {Object3D}
	 */
	get(i:string):THREE.Object3D {
		return this._slots.hasOwnProperty(i)
			? this._slots[i]
			: null;
	}

	/**
	 * Appends new slots (used during model processing)
	 * @param slots
	 */
	append(slots:{ [key:string]:THREE.Object3D } ):void {
		Object.assign(this._slots, slots);
	}
}



// WEBPACK FOOTER //
// ./src/script/app3D/Slots.ts